import Color from 'color';
import { css } from 'styled-components';

export const color = {
  primary: '#55a105',
  success: '#29A638',
  danger: '#E13C3C',
  warning: '#F89C1C',
  accent: '#8A46D7',

  textPrimary: '#666666',
  textDarkest: '#2d3e53',
  textDark: '#00dfff',
  textMedium: '#333333',
  textMediumBlue: '#78869F',
  textLight: '#666666',
  textLightBlue: '#999999',
  textBlack: '#000000',

  backgroundDarkPrimary: '#0747A6',
  backgroundMedium: '#dfe1e6',
  backgroundLight: '#ebecf0',
  backgroundLightest: '#F4F5F7',
  backgroundLightPrimary: '#D2E5FE',
  backgroundLightSuccess: '#E4FCEF',

  borderLightest: '#E1E6F0',
  borderLight: '#D8DDE6',
  borderMedium: '#B9BDC4',
  borderBlue: '#C5D3EB',
  borderDark: '#999999',

  backgroundGreen: 'rgb(78, 196, 164)',
  backgroundBlue: '#3500d3',
  backgroundPurple: 'rgb(177, 156, 217)',
  backgroundOrange: 'rgb(235, 97, 35)'
};

export const sizes = {
  appNavBarLeftWidth: 160,
  minViewportWidth: 1000,
  secondarySideBarWidth: 230
};

export const zIndexValues = {
  modal: 1000,
  dropdown: 101,
  navLeft: 100
};

export const font = {
  regular: 'font-family: "Helvetica"; font-weight: normal;',
  medium: 'font-family: "Helvetica"; font-weight: normal;',
  bold: 'font-family: "Helvetica"; font-weight: bold;',
  size: (size) => `font-size: ${size}px;`
};

export const mixin = {
  darken: (colorValue, amount) => Color(colorValue).darken(amount).string(),
  lighten: (colorValue, amount) => Color(colorValue).lighten(amount).string(),
  rgba: (colorValue, opacity) => Color(colorValue).alpha(opacity).string(),
  boxShadowMedium: css`
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  `,
  boxShadowDropdown: css`
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.31) 0px 0px 1px;
  `,
  truncateText: css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
  clickable: css`
    cursor: pointer;
    user-select: none;
  `,
  hardwareAccelerate: css`
    transform: translateZ(0);
  `,
  cover: css`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
  placeholderColor: (colorValue) => css`
    ::-webkit-input-placeholder {
      color: ${colorValue} !important;
      opacity: 1 !important;
    }
    :-moz-placeholder {
      color: ${colorValue} !important;
      opacity: 1 !important;
    }
    ::-moz-placeholder {
      color: ${colorValue} !important;
      opacity: 1 !important;
    }
    :-ms-input-placeholder {
      color: ${colorValue} !important;
      opacity: 1 !important;
    }
  `,
  scrollableY: css`
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  `,
  customScrollbar: ({ width = 8, background = color.borderDark } = {}) => css`
    &::-webkit-scrollbar {
      width: ${width}px;
    }
    &::-webkit-scrollbar-track {
      background: none;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 99px;
      background: ${background};
    }
  `,
  backgroundImage: css`
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: ${color.backgroundLight};
  `,
  link: (colorValue = color.textLink) => css`
    cursor: pointer;
    color: ${colorValue};
    ${font.medium}
    &:hover, &:visited, &:active {
      color: ${colorValue};
    }
    &:hover {
      text-decoration: underline;
    }
  `,
  tag: (
    background = color.backgroundMedium,
    colorValue = color.textDarkest
  ) => css`
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 8px;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    color: ${colorValue};
    background: ${background};
    ${font.bold}
    ${font.size(12)}
    i {
      margin-left: 4px;
    }
  `,
  ellipsisText: css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `
};
